var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-nav grid grid__base", class: _vm.rootFacets },
    [
      _c(
        "mobile-navbar",
        {
          staticClass: "mobile-nav--navbar mobile-nav--navbr__spacer",
          class: _vm.fixedNavbarClass,
          attrs: { "is-menu-open": _vm.overlayActive },
          on: { toggle: _vm.toggleMobilePanel }
        },
        [
          _c("img", {
            attrs: {
              slot: "brand-logo",
              alt: _vm.brandLogoAlt,
              src: _vm._f("staticPath")("img/im-logo-desktop-black.svg")
            },
            slot: "brand-logo"
          }),
          _vm._v(" "),
          _c("base-icon", {
            attrs: { slot: "toggle-icon", symbol: "burger", size: "large" },
            slot: "toggle-icon"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "scroll-reveal",
        {
          staticClass: "mobile-nav--scroll-reveal",
          attrs: { "element-class": "reduced-nav", offset: 160 },
          on: { onPin: _vm.onPin, onUnPin: _vm.onUnPin }
        },
        [
          _c(
            "mobile-navbar",
            {
              attrs: {
                facets: _vm.mobileNavbarFacets,
                "is-menu-open": _vm.overlayActive
              },
              on: { toggle: _vm.toggleMobilePanel }
            },
            [
              _vm.overlayActive
                ? _c("img", {
                    attrs: {
                      slot: "brand-logo",
                      alt: _vm.brandLogoAlt,
                      src: _vm._f("staticPath")("img/im-logo-desktop-white.svg")
                    },
                    slot: "brand-logo"
                  })
                : _c("img", {
                    attrs: {
                      slot: "brand-logo",
                      alt: _vm.brandLogoAlt,
                      src: _vm._f("staticPath")("img/im-logo-desktop-black.svg")
                    },
                    slot: "brand-logo"
                  }),
              _vm._v(" "),
              _vm.overlayActive
                ? _c("base-icon", {
                    attrs: {
                      slot: "toggle-icon",
                      symbol: "close",
                      size: "large"
                    },
                    slot: "toggle-icon"
                  })
                : _c("base-icon", {
                    attrs: {
                      slot: "toggle-icon",
                      symbol: "burger",
                      size: "large"
                    },
                    slot: "toggle-icon"
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-527c3ed8", { render: render, staticRenderFns: staticRenderFns })
  }
}